<template>
  <div>
    <div v-if="Object.keys(detailInfo).length">
      <detail-info v-if="!isEditing" @setState="setState" @notifyInfos="getInfos" :tgoUserInfo="detailInfo"></detail-info>
      <detail-modify v-else @setState="setState" @submit="submitInfo" :info="initData" :detailInfo="detailInfo"></detail-modify>
    </div>
    <div class="warnTip" v-else>
      <div class="warnTip-center">
        <img class="warnTip-center-img" src="../../assets/img/sad.png" />
        <div class="warnTip-center-word">暂无信息</div>
      </div>
    </div>
  </div>
</template>
<script>
import service from '@/service'
import detailInfo from './info'
import detailModify from './modify'
import lodash from 'lodash'

export default {
  data () {
    return {
      isEditing: false,
      initData: {},
      detailInfo: {}
    }
  },
  created () {
    // 教育
    // this.detailInfo = { name: '王猛' }
    service.getUserDetails().then(res => {
      this.detailInfo = res
    }).catch(err => { console.log(err) })
  },
  components: {
    detailInfo,
    detailModify
  },
  methods: {
    setState () {
      this.isEditing = !this.isEditing
    },
    submitInfo (info) {
      service.createdDetail(info)
        .then(() => {
          this.setState()
          this.detailInfo = info
        })
        .catch(err => console.log(err))
    },
    getInfos () {
      this.initData = lodash.cloneDeep(this.detailInfo)
    }
  }
}
</script>
<style scoped lang='sass'>

.warnTip
  width: 100%
  height: 100%
  display: flex
  justify-content: center
  align-items: center
  padding: 100px 0
  .warnTip-center
    .warnTip-center-img
      width: 100px
    .warnTip-center-word
      margin: 0 auto
      margin-top: 10px
      text-align: center
</style>
